import Layout from "@/components/Layout";
import { PageSEO } from "@/components/PageSEO";

const PrivacyPolicy = () => (
  <Layout>
    <PageSEO
      title="Privacy Policy | Hope & Wellness Healing Center"
      description="Read the privacy policy for Hope & Wellness Healing Center. Learn how we handle workspace inquiries and protect your information."
      canonical="https://www.hwhctherapy.com/privacy-policy"
    />
    <section className="container max-w-3xl py-16">
      <h1 className="mb-2 font-display text-3xl font-bold">Privacy Policy</h1>
      <p className="mb-10 text-sm text-muted-foreground">Last updated: March 13, 2026</p>

      <div className="prose prose-neutral max-w-none space-y-8 text-foreground/80 [&_h2]:mb-3 [&_h2]:mt-0 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_ul]:list-disc [&_ul]:pl-5">

        <div className="rounded-lg border border-accent/30 bg-accent/5 p-5 text-sm">
          <p>
            This website is for general information and workspace inquiries only. Client health information is managed exclusively through SimplePractice, a HIPAA-certified platform. hwhctherapy.com does not collect, store, or transmit protected health information.
          </p>
        </div>

        <div>
          <h2>1. What Data We Collect</h2>
          <p>We collect the following information only through our inquiry forms:</p>
          <ul>
            <li><strong>Name</strong>: your full name as provided on the inquiry form</li>
            <li><strong>Email address</strong>: so we can respond to your inquiry</li>
            <li><strong>Professional credentials</strong>: license type and years of experience, for workspace-related inquiries</li>
          </ul>
          <p>We do <strong>not</strong> collect health information, Social Security numbers, insurance details, or any other sensitive personal data through this website.</p>
        </div>

        <div>
          <h2>2. Why We Collect It</h2>
          <p>
            We collect this information solely to respond to workspace and partnership inquiries.
            Your data is used only to follow up on your request and is never used for marketing to third parties.
          </p>
        </div>

        <div>
          <h2>3. How Long We Keep It</h2>
          <p>
            Inquiry data is retained for <strong>90 days</strong> and then permanently deleted from our systems.
            If you become a workspace member, your account data is retained for the duration of your membership and deleted upon request.
          </p>
        </div>

        <div>
          <h2>4. Data Sharing</h2>
          <p>
            We do <strong>not</strong> sell, rent, or trade your personal information to third parties.
            Your data may be processed by our hosting and email delivery infrastructure solely to operate this website and respond to your inquiries.
          </p>
        </div>

        <div>
          <h2>5. Requesting Data Deletion</h2>
          <p>
            You may request deletion of your data at any time by emailing{" "}
            <a href="mailto:privacy@hwhctherapy.com" className="text-accent underline underline-offset-2 hover:text-accent/80">privacy@hwhctherapy.com</a>.
            We will process your request within 30 days.
          </p>
        </div>

        <div>
          <h2>6. Cookies</h2>
          <p>
            This site uses cookies for <strong>analytics purposes only</strong>. Analytics cookies are loaded only after you accept the cookie consent banner.
            If you decline, no analytics cookies are set. You can reset your cookie preferences at any time using the "Cookie Preferences" link in the footer.
          </p>
        </div>

        <div>
          <h2>7. Health Information</h2>
          <p>
            <strong>No health information should ever be submitted through this site.</strong> This website does not provide medical services, therapy intake forms, or patient portals.
            All client health information is managed through SimplePractice, a HIPAA-certified platform, and is never processed through hwhctherapy.com.
          </p>
        </div>

        <div>
          <h2>8. Contact</h2>
          <p>
            For privacy-related questions or to exercise your rights, contact us at:<br />
            <strong>Email:</strong> privacy@hwhctherapy.com<br />
            <strong>Address:</strong> 3500 Boston St, Suite 432, Baltimore, MD 21224
          </p>
        </div>
      </div>
    </section>
  </Layout>
);

export default PrivacyPolicy;
